import { all, takeLatest, take, fork, call, put } from 'redux-saga/effects'
import { ensureAddAvatar } from 'domain/avatar/sagas'
import { educationsPage } from 'pages/Profile/Education/sagas'
import { pointsPage } from 'pages/Profile/Points/sagas'
import { pageIsLoading } from 'domain/loading'
import * as A from 'domain/profile'
import * as L from 'domain/locations'
import * as Avatar from 'domain/avatar/actions'
import * as R from 'domain/manager/recruiters'
import * as RP from 'domain/recruiter/profile'

export function* profilePage() {
  yield all([
    fork(educationsPage),
    fork(addAvatar),
    fork(updateProfile),
    fork(getHM),
    fork(pointsPage),
    fork(initialLoad),
    fork(changePassword)
  ])
}

function* changePassword() {
  yield takeLatest(A.changePassword.TRIGGER, A.ensureChangePassword)
}

function* addAvatar() {
  yield takeLatest(Avatar.addAvatar.type, ensureAddAvatar)
  yield take(Avatar.addAvatar.success)
}

function* updateProfile() {
  yield takeLatest(A.updateProfile.TRIGGER, A.ensureUpdateProfile)
  yield take(A.updateProfile.SUCCESS)
}

function* getHM() {
  yield takeLatest(R.recruitersList.type, RP.ensureHMList)
  yield take(R.recruitersList.success)
}

function* initialLoad() {
  try {
    yield put({ type: pageIsLoading, payload: true })
    yield all([call(RP.ensureHMList), call(L.ensureGetCounties)])
    yield put({ type: 'profile/CLEAR_CITIES' })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}
